export const QUOTE_MODEL_REVISION_STATES = {
    REGISTERED: 'registered',
    PROCESSING: 'processing',
    NEEDS_CONFIGURATION: 'needs_configuration',
    NEEDS_RFQ: 'needs_rfq',
    UNRESOLVED_DFM: 'unresolved_dfm',
    NOT_MANUFACTURABLE: 'not_manufacturable',
    PURCHASABLE: 'purchasable',
    ERROR: 'error',
    DELETED: 'deleted',
}

export const QUOTE_MODEL_REVISION_FLAGS = {
    NOTREORDERABLE: 'not_reorderable',
}
